import axios, { AxiosError } from 'axios';


export  function  apiClientSubmaster(token:String) {

    const api = 
    axios.create({
        baseURL: 'https://alexios.com.br:9597/submasterAccessManagement', // Altere para o domínio
        headers:{
            Authorization: `Bearer ${token}`
        }

    }) 
    api.interceptors.response.use(
        response => response,
        (error: AxiosError) => {
            console.error("Erro na requisição:", error.message);
            return 401; // Rejeita corretamente
        }
    );
    return api
}



